import React, { useCallback, useState } from "react";
import ImageZoomModal from "./ImageZoomModal";

function ZoomableImage({ src, alt = "Immagine", className }) {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);

  if (!src) return null;

  return (
    <>
      <button
        type="button"
        className="modificaProdottiImmagineZoomTrigger"
        onClick={(event) => {
          event.stopPropagation();
          setOpen(true);
        }}
        aria-label={`${alt}: apri l'immagine ingrandita`}
      >
        <img src={src} alt={alt} className={className} title="Clicca per ingrandire" />
      </button>
      <ImageZoomModal open={open} onClose={close} src={src} alt={alt} />
    </>
  );
}

export default ZoomableImage;
